import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  Creature,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../../utilities/common_utilities';
import DandDAPI from '@utilities/smart_api';

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import SelectCreatureBox from "@dndComponents/select/SelectCreatureBox";
import ButtonBox from "@components/input/buttons/ButtonBox";

interface Props {
  char: Character;
  disabled: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();
const api = DandDAPI.getInstance();

export default function CharacterMinionsButton({ 
  char,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);
  const [custom_minion, setCustomMinion] = useState<Creature | null>(null);

  const renderCustomMinionSelect = () => {
    return (
      <div style={{ 
        height: "100%",
        overflowX: "hidden"
      }}>
        <Grid container spacing={0} direction="row">
          <Grid size={12}>
            <SelectCreatureBox
              name="Select a Creature"
              value={custom_minion?._id??""}
              onChangeObject={setCustomMinion}
            />
          </Grid>
          <Grid size={12}>
            <ButtonBox
              name="Add"
              disabled={custom_minion === null}
              onClick={ async () => {
                if (custom_minion) {
                  await api.loadObject(custom_minion);
                  const creature_instance = await char_util.creatureToCreatureInstance({ char, creature: custom_minion });
                  
                  char.minions.push(creature_instance);
                  char.changed();
                  char.subscription_holder.recalculate();
                  char.subscription_holder.minionsChanged();
                  setOpen(false);
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}
        className={`centered header ${ disabled ? "" : "clickable"}`}
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        Minions
      </Grid>
      <ModalOrDrawer
        open={ open } 
        // drawer_only
        onClose={() => {
          setOpen(false);
          setCustomMinion(null);
          char.subscription_holder.modalClosed();
        }}>
        { open && renderCustomMinionSelect() }
      </ModalOrDrawer>
    </Grid>
  );
}
